import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProgressiveRenderService {
    private static readonly ITEMS_RENDERED_AT_ONCE = 500;
    private static readonly INTERVAL_IN_MS = 10;

    progressivelyRender<T>(items: T[]): Observable<T[]> {
        const renderedItems = new BehaviorSubject<T[]>([]);
        let currentIndex = 0;

        const interval = setInterval(() => {
            const nextIndex = currentIndex + ProgressiveRenderService.ITEMS_RENDERED_AT_ONCE;
            const chunk = items.slice(currentIndex, nextIndex);

            if (chunk.length === 0) {
                clearInterval(interval);
                renderedItems.complete();
                return;
            }

            renderedItems.next([...renderedItems.getValue(), ...chunk]);
            currentIndex = nextIndex;

            if (currentIndex >= items.length) {
                clearInterval(interval);
                renderedItems.complete();
            }
        }, ProgressiveRenderService.INTERVAL_IN_MS);

        return renderedItems.asObservable();
    }
}
